import { FunctionComponent} from 'react'
import {
    ColorOptionsContainer,
    ColorListItem,
    ColorItem,
    PaletteHeading,
    PaletteTitle,
    PaletteSelection,
    PlateColorPaletteContainer,
    ColorItemMobile} from './PlateColorPalette.styles'
import {List} from 'semantic-ui-react'
import { isMobile } from '@utils/Helpers';
import { PlateColor } from '~/dataModels/ProductModels';

interface PlateColorPaletteProps{
    title?: string
    card: boolean
    colors: Array<PlateColor>
    selectedColor: PlateColor
    handleColorChange: (data: string) => void,
    enabled?: boolean,
    darkTheme: boolean
}

///GET LIST OF COLORS AND RETRUN THE COLOR NAME

const PlateColorPalette :FunctionComponent<PlateColorPaletteProps> = (props) =>{

    const {card, colors, title, selectedColor, darkTheme} = props;

    return (
        <PlateColorPaletteContainer>
        {
            !card &&
            <PaletteHeading>
                <PaletteTitle darkTheme={darkTheme}>{title}</PaletteTitle>
                <PaletteSelection darkTheme={darkTheme}>- {selectedColor.name}</PaletteSelection>
            </PaletteHeading>
        }
        <ColorOptionsContainer>
            <List horizontal>
                {colors.map((color,key)=>{
                    return (<ColorListItem isMobile={isMobile()}
                                key={color.name} card={card}>
                        {isMobile() ? 
                        <ColorItemMobile 
                            card={false}
                            selected={selectedColor.name === color.name}
                            onClick={()=> props.enabled && props.handleColorChange(color.name)} 
                            color={color.color} 
                            darkTheme={darkTheme}/>:
                        <ColorItem
                            card = {card}
                            selected={selectedColor.name === color.name}
                            onClick={()=> props.enabled && props.handleColorChange(color.name)}
                            color={color.color} 
                            darkTheme={darkTheme}/>}
                        
                    </ColorListItem>);
                })}
            </List>
        </ColorOptionsContainer>
        </PlateColorPaletteContainer>
    )
}

PlateColorPalette.defaultProps = {
    title: "",
    card: false,
    enabled: true,
    darkTheme:false
}

export default PlateColorPalette